module.exports = __webpack_public_path__ + "assets1783936157458/img/kehu-select.c73b67a4.svg";